import React from 'react';
import { Box, Typography } from '@mui/material';
import { LuUser } from 'react-icons/lu';
import { elliottTokens as t } from '../tokens';
import { messageBodySx } from './ElliottMessage';
import { MOBILE_SX } from '../../../../../../mobile/mobileApp';

// Learner's message — right-aligned, brandy outline bubble, avatar on the right.
const LearnerMessage: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box
    sx={{
      display: 'flex',
      gap: '20px',
      alignItems: 'flex-start',
      justifyContent: 'flex-end',
      pl: '130px',
      // Phone: a little indent marks it as the learner's side, the rest is reading width.
      [MOBILE_SX]: { gap: '10px', pl: '36px' }
    }}
  >
    <Box
      sx={{
        flex: 1,
        minWidth: 0,
        border: `2px solid ${t.brandLight}`,
        px: '16px',
        py: '12px',
        borderRadius: '8px 0 8px 8px' // square top-right, anchored to the avatar
      }}
    >
      <Typography sx={messageBodySx}>{children}</Typography>
    </Box>
    <Box
      sx={{
        flexShrink: 0,
        width: 40,
        height: 40,
        [MOBILE_SX]: { width: 32, height: 32 },
        borderRadius: '50%',
        bgcolor: t.surface,
        border: `1px solid ${t.borderDim}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: t.textSecondary
      }}
    >
      <LuUser size={20} />
    </Box>
  </Box>
);

export default LearnerMessage;
